import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-white dark:bg-background-dark border-t border-gray-200 dark:border-gray-700 mt-auto">
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <p className="text-center text-sm text-gray-600 dark:text-gray-400">
          {t('footer.copyright')} <br className="sm:hidden" />
          <span className="hidden sm:inline">|</span> {t('footer.craftedBy')} <br className="sm:hidden" />
          <span className="hidden sm:inline">|</span> {t('footer.university')} <br className="sm:hidden" />
          <span className="hidden sm:inline">|</span> {t('footer.email')} <br className="sm:hidden" />
          <span className="hidden sm:inline">|</span> {t('footer.feedback')}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
